import Container from '@ui/container/container';
import type { ResolvedEmailBlock } from '../../../templates/widgets/block-types';
import ColorPill from '../controls/color-pill';
import ScaleSlider from '../controls/scale-slider';

const MIN_HEIGHT = 0;
const MAX_HEIGHT = 100;
// matches the fallback BlockRenderer hands SpacerWidget when the block carries no height of its own
const DEFAULT_HEIGHT = 24;

function parseHeight(value: unknown): number {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const parsed = parseInt(value, 10);
    if (!Number.isNaN(parsed)) return parsed;
  }
  return DEFAULT_HEIGHT;
}

interface SpacerStylePanelProps {
  block: ResolvedEmailBlock;
  onUpdateStyle: (key: string, value: unknown) => void;
  onUpdateProp: (key: string, value: unknown) => void;
}

export default function SpacerStylePanel({ block, onUpdateStyle, onUpdateProp }: SpacerStylePanelProps) {
  const style = block.style ?? {};
  const height = parseHeight(block.props.height);

  return (
    <Container className="flex-column gap-16" padding="0 16px">
      <ColorPill
        label="Background color"
        value={style.background as string | undefined}
        isOverridden={style.background !== undefined}
        onChange={(value) => onUpdateStyle('background', value)}
        onReset={() => onUpdateStyle('background', undefined)}
      />

      <Container className="flex ai-center gap-12" background="var(--gray-800)" borderRadius="12px" padding="12px 16px">
        <ScaleSlider
          value={height}
          onChange={(value) => onUpdateProp('height', value)}
          label="height"
          inputLabel="px"
          min={MIN_HEIGHT}
          max={MAX_HEIGHT}
        />
      </Container>
    </Container>
  );
}
